import React from 'react';
import FAQ from '../components/FAQ';
import './FAQPage.css';

const FAQPage = () => {
    return (
        <div className="faq-page">
            <div className="page-header">
                <h1>Frequently Asked Questions</h1>
                <p className="page-description">
                    Everything you need to know about 4-Quarter Projections, pricing calculations,
                    and business planning for your OTT streaming platform. Find answers to common
                    questions about revenue models, cost structures, and growth projections.
                </p>
            </div>
            <FAQ />
        </div>
    );
};

export default FAQPage;
